// extracted by mini-css-extract-plugin
export default {"newPasswordFormItem":"current-user-password-modal_newPasswordFormItem__UbqEN"};